import React, { useState, useRef, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import { mockPlans } from '../constents/Plans/plansDetails';
import { PricingPart } from "./Pricing";



const Plans = () => {

    const SMART_HIRING_TOOLS = {
        heading: 'Mock Interview by Zepcruit ',
        subHeading: 'Step into a real interview simulation tailored to you.',
        description: "Know exactly where you stand in 15 minutes.",
        plans: mockPlans,
        features: [
            { point: "10 AI-powered, role-specific questions", dropdown: "built around real interview scenarios" },
            { point: "Choose your challenge modes –  Test yourself by", dropdown: "1. Level (Easy, Medium, Hard)\n2. Skills (Soft skills or technical / core skills) \n3. Personal or workplace values (integrity, ownership and more)"},
            { point: "Feel the real pressure", dropdown: "3 minutes to think, speak, and impress" },
            { point: "Get instant feedback", dropdown: " a clear evaluation report in just 10–15 mins." },
            { point: "Gift it to your friends", dropdown: "Don’t just practice alone. Challenge your friends and compare scores." },
        ],
        // warn: "***Will be avaialble after the candidate from the uploaded database of CV, signs up and gives the DISC test on Zepcruit.ai (Disc test insights is an add on and charges extra)",
        validity: "Bronze, Silver and Gold package will consist of the below: Validity 6 months",
        
    }
    // const MOCK_INTERVIEW_PRICINGS = {
    //     heading: ' Mock Interview by Zepcruit ',
    //     subHeading: 'Step into a real interview simulation tailored to you”',
    //     description: " Know exactly where you stand in 15 minutes!",
    //     plans: [
    //         {
    //             name: "Basic",
    //             img: Bronze,
    //             desc: "1 Mock AI Interview",
    //             price: "₹39",
    //             paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
    //             basePrice: '₹99',
    //         },
    //         {
    //             name: "Silver",
    //             img: Silver,
    //             desc: "10 job posts",
    //             price: "₹94,990",
    //             basePrice: '₹142,501',
    //             isRecommended: true, // Marking as recommended
    //             paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
    //         },
    //         {
    //             name: "Gold",
    //             img: Gold,
    //             desc: "50 job posts",
    //             basePrice: '₹675,001',
    //             price: "₹4,49,950",
    //             paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
    //         },
    //         {
    //             name: "Enterprise",
    //             img: EnterPrice,
    //             desc: "Custom",
    //             price: "Contact Us",
    //             paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
    //             isEnterprise: true
    //         }
    //     ],
    //     features: [
    //         { point: "Candidate Talent Pool ", dropdown: "Candidate Talent Pool – Each job post is screened from hundreds of job seeking candidates from Zepcruit's database  for the best fit. Larger pool ensures better hire." },
    //         { point: "DISC", dropdown: "Understand candidates personality type (D)ominance, (i)nfluence, (S)teadiness and (C)onscientiousness" },
    //         { point: "Smart DISC Insights***", dropdown: "Gain deep DISC insights of the candidate to guage the right personality fit for the role" },
    //         { point: "AI-Powered CV Ranking", dropdown: "Ranks and shortlist the best candidates for the role." },
    //         { point: "Smart CV Insights", dropdown: "Get detailed candidate ranking summaries for better decision-making." },
    //         { point: "AI-Powered Video Interview Analytics", dropdown: " Get question-wise performance ranking." },
    //         { point: "AI-Generated Interview Summaries", dropdown: "Get question-wise insights into candidates' responses." },
    //         { point: "AI-Led Video Interviews (15-25 Sessions) ", dropdown: "AI interviews the top 10% of candidates, based on skills, JD, CV, and Company values" },
    //         { point: "Emotion Mapping ", dropdown: " Emotion analysis of each question/answers of interviewed candidates" },
    //         { point: "Exclusive Video Access (100 Candidates, 60GB Storage)", dropdown: "Store & review interviews anytime." },
    //         { point: "Fraud check", dropdown: "Zepcruit’s built-in protection against impersonation, prompts, and any sort" },
    //     ],
    //     warn: "***Will be avaialble after the candidate from the uploaded database of CV, signs up and gives the DISC test on Zepcruit.ai (Disc test insights is an add on and charges extra)",
    //     validity: "Bronze, Silver and Gold package will consist of the below: Validity 6 months",
    // }


    // ---------------------------------------------------------------

    return (
       
           <div className=" min-h-screen w-full m-0 p-0">
               {/* {bottom section} */}
               <PricingPart details={SMART_HIRING_TOOLS} plansOnly={false} />
           </div>
        
    );
};

export default Plans;













































//  < div className="flex flex-col px-4 sm:px-8 xl:px-16 mt-8 lg:mt-16" >

//             {/* {bottom section right} */}
             
//             {
//                 mockPlans?.map((item, index) => (
//                     <div key={index} className="w-full lg:w-[60%] flex flex-col justify-center" >
//                         <div className="py-4 rounded-lg">
//                             {/* DISC Test Summary */}
//                             <div className="border border-gray-700 rounded-2xl p-4 mb-4 flex justify-between items-center">
//                                 <h3 className="font-semibold lg:text-2xl text-lg">{item?.des}</h3>
//                                 <div className="text-right">

//                                     <div className="flex flex-col">
//                                         <span className="font-semibold">OFFER PRICE</span>
//                                         <span className="text-black font-semibold">₹{item.price}</span>
//                                         {/* <span className="line-through text-gray-400">₹99</span> */}
//                                     </div>
//                                     <div
//                                         className="w-full bg-[#F74D00] text-white font-semibold py-3 rounded-full transition mt-3 sm:mt-4"
//                                     >
//                                         <Link style={{ display: ' flex', width: '100%', justifyItems: 'center', alignItems: 'center', cursor: "pointer" }}
//                                             to={`/purchase?plan_name=${item.planName}&plan_type=MOCK`}> <span className=" text-center mx-auto uppercase">Buy</span> </Link>
//                                     </div>
//                                 </div>

//                             </div>
//                         </div>
//                     </div >
//                 ))
//             }
           
//         </div >

































// {/* For End To End Hiring*/}
// <div className="flex flex-col">
//     <div className=" flex gap-8 mt-4">
//         <div className=" h-fit flex flex-col flex-1 bg-white rounded-[24px] p-8">
//             <h1 className="text-2xl text-center font-extrabold ">{EndToEndHiring.text}</h1>
//             {EndToEndHiring?.plans.map((plan, index) => (
//                 <div
//                     key={index}
//                     onClick={() => setPlanDetails({ 'plan_type': EndToEndHiring.PlanType, 'plan_name': plan.planName })}
//                     className={` hover:bg-gray-50 cursor-pointer w-full flex flex-col sm:flex-row items-center justify-between p-3 sm:p-4 rounded-[24px]`}

//                 >
//                     {/* Left Section */}
//                     <div className="flex items-center space-x-3 sm:space-x-4 w-full sm:w-auto">
//                         <img src={plan.img} alt={plan.name} className="w-24 h-auto" />
//                         <div className="text-left">
//                             {plan.isRecommended && (
//                                 <span className="bg-black text-white text-xs px-2 py-1 rounded-md uppercase">
//                                     Recommended
//                                 </span>
//                             )}
//                             <h3 className="text-base sm:text-lg xl:text-xl font-bold">{plan.name}</h3>
//                             <p className="text-gray-600 text-xs sm:text-sm">{plan.desc}</p>
//                         </div>
//                     </div>

//                     {/* Right Section */}
//                     <div className="text-center sm:text-right mt-2 ">
//                         <p className="text-black text-xs sm:text-sm xl:text-lg font-medium mt-1">
//                             {plan.isEnterprise ? "PRICE" : "OFFER PRICE"}
//                         </p>
//                         <span className="text-base sm:text-lg xl:text-xl text-black">
//                             {plan.price}
//                         </span>
//                     </div>
//                 </div>


//             ))}
//             {/* getStart Button */}

//         </div>
//         <div className=" flex-1 flex flex-col bg-white rounded-[24px] p-8">
//             <h1 className="text-2xl text-center font-extrabold mb-6 ">Bronze, Silver and Gold package will consist of the below: Validity 6 months</h1>
//             <ul>
//                 {EndToEndHiring?.features?.map((item, index) => (<li className="" key={index}>• {item}</li>))}
//             </ul>
//             <p>{EndToEndHiring.warn}</p>
//         </div>
//     </div>
// </div>

// {/* For Smart Hiring*/}
// <div className="flex flex-col">
//     <div className=" flex gap-8 mt-4">
//         <div className=" h-fit flex flex-col flex-1 bg-white rounded-[24px] p-8">
//             <h1 className="text-2xl text-center font-extrabold ">{ForSmartHiring.text}</h1>
//             {ForSmartHiring?.plans.map((plan, index) => (
//                 <div
//                     key={index}
//                     className={` hover:bg-gray-50 cursor-pointer w-full flex flex-col sm:flex-row items-center justify-between p-3 sm:p-4 rounded-[24px] `}
//                     onClick={() => setPlanDetails({ 'plan_type': ForSmartHiring.PlanType, 'plan_name': plan.planName })}
//                 >
//                     {/* Left Section */}
//                     <div className="flex items-center space-x-3 sm:space-x-4 w-full sm:w-auto">
//                         <img src={plan.img} alt={plan.name} className="w-24 h-auto" />
//                         <div className="text-left">
//                             {plan.isRecommended && (
//                                 <span className="bg-black text-white text-xs px-2 py-1 rounded-md uppercase">
//                                     Recommended
//                                 </span>
//                             )}
//                             <h3 className="text-base sm:text-lg xl:text-xl font-bold">{plan.name}</h3>
//                             <p className="text-gray-600 text-xs sm:text-sm">{plan.desc}</p>
//                         </div>
//                     </div>

//                     {/* Right Section */}
//                     <div className="text-center sm:text-right mt-2 ">
//                         <p className="text-black text-xs sm:text-sm xl:text-lg font-medium mt-1">
//                             {plan.isEnterprise ? "PRICE" : "OFFER PRICE"}
//                         </p>
//                         <span className="text-base sm:text-lg xl:text-xl text-black">
//                             {plan.price}
//                         </span>
//                     </div>
//                 </div>


//             ))}

//         </div>
//         <div className=" flex-1 flex flex-col  bg-white rounded-[24px] p-8">
//             <h1 className="text-2xl text-center font-extrabold mb-6">All package's validity 6 months</h1>
//             <ul>
//                 {ForSmartHiring?.features?.map((item, index) => (<li className="" key={index}>• {item}</li>))}
//             </ul>
//             <p>{ForSmartHiring.warn}</p>
//         </div>
//     </div>


// </div>
